// react
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// other packages
import cx from 'classnames';
// components
import { HashtagAutocomplete } from '../HashtagAutocomplete';
// types
import Checkbox from 'shared/components/Checkbox';
import { IHashtag } from 'redux/hashtag-service/types';
// formik
import { Field } from 'formik';
// styles
import styles from './index.module.scss';
import Select from 'shared/components/Inputs/Select';
import InputErrorHint from 'shared/components/InputErrorHint';

interface IHashtagFieldProps {
	options: Array<IHashtag>;
	isVolunteer?: boolean;
	isErrorArePresent?: boolean;
	isVisibleHashtagField?: boolean;
	handleChangeVisibleHashtag: (checked: boolean, _value?: number | undefined) => void;
	disabled?: boolean;
	isRequired?: boolean;
	isDisableHeight?: boolean;
}

export const HashtagField: FC<IHashtagFieldProps> = ({
	isErrorArePresent,
	isVolunteer = false,
	isVisibleHashtagField,
	handleChangeVisibleHashtag,
	options,
	disabled,
	isRequired,
	isDisableHeight,
}) => {
	const [isLoggedInAsVolunteer, setIsVolunteer] = useState(false);

	useEffect(() => {
		setIsVolunteer(!!localStorage.getItem('volunteerId'));
	}, []);

	const remapToSelectOptions = (ops: Array<IHashtag>) =>
		ops.map(option => ({ title: `#${option.name}`, value: option.id }));

	return (
		<>
			<div className={styles.hashtag__wrapper}>
				<Checkbox
					disabled={disabled || isRequired}
					changeHandle={handleChangeVisibleHashtag}
					defaultChecked={isVisibleHashtagField}
				/>
				<p className={cx(isVolunteer ? styles.hashtag_label__volunteer : styles.hashtag_label__admin)}>
					Does This Opportunity Have a Category?
					{(isRequired && <span className={styles.hashtag_label__required}>*</span>) || <></>}
				</p>
			</div>
			{isVisibleHashtagField && (
				<div className={styles.hashtag_wrapper}>
					{isLoggedInAsVolunteer ? (
						<>
							<Field
								name="tagId"
								options={remapToSelectOptions(options)}
								disabled={!options.length || isErrorArePresent}
								placeholder="Select category"
								error={isErrorArePresent ? 'Please select Organization/School' : ''}
								component={Select}
								isDisabledMargin={isErrorArePresent}
								isSmallHeight={true}
								isDisableHeight={true}
							/>
							{isErrorArePresent && (
								<div className={styles.error}>
									<InputErrorHint errorText="Please select Organization/School" />
								</div>
							)}
						</>
					) : (
						<Field
							name="tagId"
							label=""
							options={options}
							placeholder="Select category"
							isDisableHeight={isDisableHeight}
							isHashtagField={true}
							component={HashtagAutocomplete}
							noOptionsText="No categories found"
							isErrorArePresent={isErrorArePresent}
						/>
					)}
				</div>
			)}
		</>
	);
};
